import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { catInfo, money } from "@/lib/constants";

export const PickPlaceDialog = ({ open, onOpenChange, planId, replacing, onPick }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!open) return;
    setItems(null);
    api.get(`/plans/${planId}/candidates`, { params: replacing ? { cat: replacing.cat } : {} }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [open, planId, replacing]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="z-[1250] sm:max-w-lg max-h-[80vh] flex flex-col" data-testid="pick-place-modal">
        <DialogHeader>
          <DialogTitle className="text-xl">{replacing ? `Replace ${replacing.name}` : "Add a stop"}</DialogTitle>
          <DialogDescription>Real places near your route from OpenStreetMap. {replacing ? "Similar places are listed first." : "Closest first."}</DialogDescription>
        </DialogHeader>
        <div className="overflow-y-auto -mx-2 px-2 space-y-1.5">
          {!items && <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-stone-400" /></div>}
          {items?.length === 0 && <p className="text-sm text-stone-500 py-6 text-center">No more nearby options. Try a new plan with a larger distance.</p>}
          {items?.map((c, i) => {
            const Icon = catInfo(c.cat).icon;
            return (
              <button key={c.pid} data-testid={`pick-place-option-${i}`} onClick={() => onPick(c)}
                className="w-full text-left flex items-center gap-3 rounded-xl border border-stone-200 px-3 py-2.5 hover:border-[#2F7D55] hover:bg-[#EAF4EC] transition-colors">
                <Icon className="w-5 h-5 text-[#163A2B] shrink-0" />
                <span className="min-w-0 flex-1">
                  <span className="block font-semibold text-sm truncate">{c.name}</span>
                  <span className="block text-xs text-stone-500">{catInfo(c.cat).label} · {c.km} km from start · {c.hours ? "hours listed" : "hours not confirmed"}</span>
                </span>
                <span className="font-mono text-xs text-slate-600 whitespace-nowrap">{money(c.cost_min, c.cost_max)} est.</span>
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};
